import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2c3c140c&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=2c3c140c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c140c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('C:\\gitlab\\college-and-career-public\\components\\Navigation.vue').default})
